var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _g4, _path8, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCursorHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_581)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0266 13.0881C14.0276 13.0861 14.0296 13.0831 14.0306 13.0811L14.0526 13.1631L14.0266 13.0881ZM15.5216 18.5601C15.5216 18.4561 15.5546 18.3551 15.6136 18.2701L16.4616 17.0761C16.8156 16.5771 17.0036 15.9881 17.0036 15.3731V10.4971C17.0036 8.42206 16.7826 8.08006 16.0276 8.01606V9.49706C16.0276 9.77406 15.8046 9.99706 15.5276 9.99706C15.2516 9.99706 15.0276 9.77406 15.0276 9.49706V7.57206C14.9696 7.39606 14.7396 6.91906 13.9696 6.92906V9.49706C13.9696 9.77406 13.7456 9.99706 13.4696 9.99706C13.1926 9.99706 12.9696 9.77406 12.9696 9.49706V6.59406C12.8756 6.42806 12.5986 6.04206 12.0846 5.99706V9.49706C12.0846 9.77406 11.8606 9.99706 11.5846 9.99706C11.3076 9.99706 11.0846 9.77406 11.0846 9.49706V6.07306C11.0836 6.06106 11.0776 6.05106 11.0776 6.03906V3.99706C11.0776 3.43906 10.6906 3.01106 10.1776 3.00006C9.6306 3.01206 9.1136 3.48706 9.1136 3.99706V11.1541C9.1136 11.3661 8.9806 11.5541 8.7816 11.6251C8.5856 11.6971 8.3606 11.6341 8.2266 11.4721L6.6996 9.61006C6.5236 9.43406 6.2596 9.31906 5.9876 9.31906H5.9866C5.7146 9.31906 5.4506 9.43406 5.2426 9.64406C4.9146 9.97706 4.9266 10.5351 5.2686 10.8881L6.6486 12.8641C7.2676 13.7531 7.7656 14.7241 8.1276 15.7481C8.4566 16.7521 9.2266 18.2211 9.8456 18.2211C10.1206 18.2211 10.3446 18.4441 10.3456 18.7201L10.3466 19.4971H15.5216V18.8311V18.5601Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_581",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 2,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.085 9.88208V10.8821H17.9834V9.88208H18.085V9.88208Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_581)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9834 9.88208C17.9884 9.99508 17.9924 10.1091 17.9944 10.2311C17.9924 10.1111 17.9894 9.99208 17.9834 9.88208Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11_581",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 21,
    width: 2,
    height: 2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3407 22.4976H8.3407V21.8363H9.3407V22.4976Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11_581)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3407 21.8363C8.5027 22.0753 8.7317 22.2663 9.0007 22.3793C8.7317 22.2663 8.5027 22.0753 8.3407 21.8363Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11_581",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 19,
    width: 2,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.085 19.6155V20.6155H17.1685V19.6155H18.085V19.6155Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11_581)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1685 19.6155C17.3475 19.6915 17.5095 19.8015 17.6455 19.9365C17.5095 19.8015 17.3475 19.6915 17.1685 19.6155Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00082 19.6155C8.73182 19.7295 8.50282 19.9195 8.34082 20.1585C8.50282 19.9195 8.73182 19.7295 9.00082 19.6155Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5845 20.4976H16.0005H9.84847H9.58447C9.30847 20.4976 9.08447 20.7216 9.08447 20.9976C9.08447 21.2736 9.30847 21.4976 9.58447 21.4976H16.5845C16.8605 21.4976 17.0845 21.2736 17.0845 20.9976C17.0845 20.7216 16.8605 20.4976 16.5845 20.4976Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11_581",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 22,
    width: 2,
    height: 1
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.085 22.0583V22.4976H17.1683V22.0583H18.085V22.0583Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11_581)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6453 22.0583C17.5093 22.1943 17.3483 22.3043 17.1683 22.3793C17.3483 22.3043 17.5093 22.1943 17.6453 22.0583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11_581",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 1,
    width: 15,
    height: 22
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0423 22.4976H4V1.99957H11.0423H18.0845V22.4976H11.0423Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11_581)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5845 21.4976H9.58448C9.30848 21.4976 9.08448 21.2736 9.08448 20.9976C9.08448 20.7216 9.30848 20.4976 9.58448 20.4976H9.84848H16.0005H16.5845C16.8605 20.4976 17.0845 20.7216 17.0845 20.9976C17.0845 21.2736 16.8605 21.4976 16.5845 21.4976ZM10.3475 19.4976L10.3455 18.7196C10.3445 18.4436 10.1205 18.2206 9.84548 18.2206C9.22748 18.2206 8.45648 16.7516 8.12748 15.7486C7.76548 14.7236 7.26848 13.7526 6.64848 12.8646L5.26948 10.8886C4.92648 10.5356 4.91448 9.97657 5.24248 9.64457C5.45048 9.43457 5.71448 9.31857 5.98648 9.31857H5.98748C6.25948 9.31857 6.52348 9.43457 6.69948 9.61057L8.22748 11.4716C8.36048 11.6346 8.58548 11.6976 8.78148 11.6246C8.98048 11.5536 9.11348 11.3656 9.11348 11.1546V3.99757C9.11348 3.48657 9.63048 3.01157 10.1775 2.99957C10.6905 3.01057 11.0775 3.43957 11.0775 3.99757V6.03957C11.0775 6.05157 11.0835 6.06157 11.0845 6.07257V9.49757C11.0845 9.77357 11.3085 9.99757 11.5845 9.99757C11.8605 9.99757 12.0845 9.77357 12.0845 9.49757V5.99657C12.5985 6.04257 12.8755 6.42757 12.9695 6.59457V9.49757C12.9695 9.77357 13.1925 9.99757 13.4695 9.99757C13.7455 9.99757 13.9695 9.77357 13.9695 9.49757V6.92857C14.7395 6.91957 14.9695 7.39657 15.0275 7.57157V9.49757C15.0275 9.77357 15.2515 9.99757 15.5275 9.99757C15.8045 9.99757 16.0275 9.77357 16.0275 9.49757V8.01657C16.7825 8.08057 17.0035 8.42257 17.0035 10.4976V15.3726C17.0035 15.9886 16.8155 16.5776 16.4615 17.0766L15.6135 18.2706C15.5545 18.3556 15.5225 18.4566 15.5225 18.5596V18.8306V19.4976H10.3475ZM17.6455 19.9366C17.5095 19.8016 17.3475 19.6916 17.1685 19.6156C16.9895 19.5396 16.7915 19.4976 16.5845 19.4976H16.5225V18.8306V18.7196L17.2775 17.6556C17.7525 16.9856 18.0035 16.1966 18.0035 15.3726V10.4976C18.0035 10.3986 17.9965 10.3246 17.9945 10.2316C17.9925 10.1096 17.9885 9.99557 17.9835 9.88157C17.8845 7.54157 17.2095 7.07657 15.8745 7.00857C15.5935 6.45557 14.9355 5.83257 13.7355 5.93757C13.5025 5.59757 13.0315 5.13957 12.2875 5.03057C12.2255 5.00257 12.1575 4.98557 12.0845 4.98557H12.0775V3.99757C12.0775 2.89857 11.2525 2.02157 10.1775 1.99957C9.05948 2.02257 8.11348 2.93757 8.11348 3.99757V9.75857L7.44148 8.94157C7.04648 8.53957 6.52948 8.31857 5.98748 8.31857H5.98648C5.44548 8.31857 4.92848 8.53957 4.53148 8.94157C3.82348 9.65857 3.83248 10.8436 4.49948 11.5216L5.82848 13.4346C6.39648 14.2506 6.85248 15.1416 7.18048 16.0706C7.33348 16.5376 8.08948 18.6596 9.34648 19.1286L9.34748 19.5216C9.22648 19.5406 9.10948 19.5696 9.00048 19.6156C8.73148 19.7296 8.50248 19.9196 8.34048 20.1586C8.17848 20.3986 8.08448 20.6866 8.08448 20.9976C8.08448 21.3086 8.17848 21.5966 8.34048 21.8366C8.50248 22.0756 8.73148 22.2656 9.00048 22.3796C9.18048 22.4556 9.37748 22.4976 9.58448 22.4976H16.5845C16.7915 22.4976 16.9895 22.4556 17.1685 22.3796C17.3475 22.3036 17.5095 22.1936 17.6455 22.0586C17.9165 21.7866 18.0845 21.4116 18.0845 20.9976C18.0845 20.5836 17.9165 20.2086 17.6455 19.9366Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_581",
    x: 1,
    y: -0.000427246,
    width: 20.0845,
    height: 26.498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_581"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_581",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorHand);
export default __webpack_public_path__ + "static/media/cursor_hand.4ef99e8e80a380791eea670841632ada.svg";
export { ForwardRef as ReactComponent };